export default [
  // 首页
  {
    path: "/",
    name: "index",
    component: () => import("@/views/Index/index.vue"),
  },
  {
    path: "/qualifications",
    name: "qualifications",
    component: () => import("@/views/Qualifications/qualificationsShow.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/News/indexs.vue"),
  },
  {
    path: "/newsDetails",
    name: "newsDetails",
    component: () => import("@/views/News/newsDetails.vue"),
  },
  {
    path: "/engine",
    name: "engine",
    component: () => import("@/views/Engine/index.vue"),
  },
  {
    path: "/according",
    name: "according",
    component: () => import("@/views/According/index.vue"),
  },
  {
    path: "/authorization",
    name: "authorization",
    component: () => import("@/views/Authorization/index.vue"),
  },
  {
    path: "/updatelog",
    name: "updatelog",
    component: () => import("@/views/Updatelog/index.vue"),
  },
  {
    path: "/list",
    name: "list",
    component: () => import("@/views/Updatelog/list.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/Updatelog/detail.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Updatelog/search.vue"),
  },
  {
    path: "/joinUs",
    name: "joinUs",
    component: () => import("@/views/JoinUs/index.vue"),
  },
  {
    path: "/tg",
    name: "tg",
    component: () => import("@/views/TgList/index.vue"),
  },
  {
    path: "*",
    name: "index",
    redirect: "/",
  },
];
